import { Job, JobDTO } from "./Job";

export interface ImportDTO extends JobDTO {}

export class Import extends Job {}
